import type { SVGProps } from "react";

const SvgAccordionArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="6"
    fill="none"
    viewBox="0 0 10 6"
    role="img"
    {...props}
  >
    <path d="M1 1L5 5L9 1" stroke="currentColor" strokeLinecap="round" />
  </svg>
);

export default SvgAccordionArrow;
